import { Play, Pause, SkipBack } from "lucide-react";

const TrackControls = ({ isPlaying, onPlayPause, onRestart, isActive, trackNumber }) => {
  return (
    <div className={`track-controls track-${trackNumber}`} data-testid={`track-controls-${trackNumber}`}>
      <button 
        className={`track-btn restart-btn ${!isActive ? 'disabled' : ''}`}
        onClick={onRestart}
        disabled={!isActive}
        title="Restart track"
        data-testid={`restart-${trackNumber}`}
      >
        <SkipBack size={16} />
      </button>
      <button 
        className={`track-btn play-pause-btn ${isPlaying ? 'playing' : ''} ${!isActive ? 'disabled' : ''}`}
        onClick={onPlayPause}
        disabled={!isActive}
        title={isPlaying ? 'Pause' : 'Play'}
        data-testid={`play-pause-${trackNumber}`}
      >
        {isPlaying ? <Pause size={18} /> : <Play size={18} />}
      </button>
    </div>
  );
};

export default TrackControls;
